export const wootricAccountToken = process.env.REACT_APP_WOOTRIC_ACCOUNT_TOKEN
